export default __webpack_public_path__ + "static/media/amex.f1942061.svg";